<template>
    <!-- 查看明细弹窗 -->
    <a-modal
      width="50%"
      :visible="collectionVisible"
      title="收款明细"
      :maskClosable="false"
      @cancel="collectionVisible = false"
      :footer="null"
    >
      <a-table :columns="columns" :data-source="data"> </a-table>
    </a-modal>
</template>

<script>

export default {
    
    data () {
        const columns = [
                {
                    title: '费用类型',
                    dataIndex: 'commissionType',
                    key: 'commissionType',
                    scopedSlots: { customRender: 'commissionType' }
                },
                {
                    title: '应收',
                    dataIndex: 'receivableAmount',
                    key: 'receivableAmount',
                    scopedSlots: { customRender: 'receivableAmount' }
                },
                {
                    title: '实收',
                    dataIndex: 'realIncome',
                    key: 'realIncome',
                    scopedSlots: { customRender: 'realIncome' }
                },
                {
                    title: '未收',
                    dataIndex: 'notReceivedAmount',
                    key: 'notReceivedAmount',
                    scopedSlots: { customRender: 'notReceivedAmount' }
                },
                {
                    title: '收款时间',
                    dataIndex: 'proceedsTime',
                    key: 'proceedsTime',
                    scopedSlots: { customRender: 'proceedsTime' }
                }
            ]
        return {
            collectionVisible:false,
            columns,
            data:[]
        }
    },
    methods:{
        setValue(values){
            this.data = values
        }
    }
}
</script>